module.exports = __webpack_public_path__ + "img/alarm-fill.05e4ff05.svg";